class App {
  constructor() {
    this.usbIds = ["202109031125600001", "201604211753030001"]
    this.preDefinedApps = {
      BLUETOOTH: "244115188075859015",
      MIRACAST: "144115188075855880",
      YOUTUBE: "144115188075859002",
      BROWSER: "144115188075855877",
      USBMUSIC: "201604211753030002"
    }
  }
  _init = async () => {
    return true
  }

  getList = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.preloadedApplication.getPreloadedApplicationList({
      onSuccess: payload => promise.resolve(payload.list),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    const res = await promise.done
    if (!res) return res

    const applist = []
    res.forEach(app => applist.push({ key: app.id, value: app.title }))

    const foundUsb = this.usbIds.find(id => applist.some(app => app.key === id))
    if (foundUsb) this.preDefinedApps.USB = foundUsb

    hcap.application.RegisterSIApplicationList({
      tokenList: [
        {
          id: "netflix",
          token:
            "PmAZUuYFt8iWfC9rMeXxcXKH13f2uzbRGAXt9UCFAGA6rrWkTVNFOImqok5M4NvDoRiX/YzrU0W+qWM/95xYmSyKAmPi4iAdMaH+Jx1/v37Y7It/g3zLLq9n6sSezE+e6PifONWq4xAufkzIZVtvvrcNRLJ+w6eoUFOWjTyW/ZHk5YArNYyE10ZECyDg+cfzhw0K2WoTj/doiGFQMh4oB/KOB0pgww1NjLeP9K+XOF4wPFVerqu3scBqBG2YfoBLeT7FJvaETO+AkF+Hqv3Iv+k7TPHBKxULwMHpD/ScdsVbFFXiFcwUNcC0NYo5WnxoSQryEyNhs689iMa5gipU0Q=="
        }
      ],
      onSuccess: () => {
        applist.push({ key: "244115188075859013", value: "Netflix" })
        window.netflix = true
      },
      onFailure: () => {}
    })

    hcap.application.RegisterSIApplicationList({
      tokenList: [
        {
          id: "com.webos.chromecast",
          token:
            "K6Upi3koeLmBIwci9BidbYs1BxfZw7iWo5SYG2JeFzpGojeQ8v2r7PPJdiShBtyQdM5v+rmTGczUUoyw92v1ykfO1fUbevPhGymUiZrpHUOWwtrV2Lz3JH70xdSJAcFjoN+OSLbafvR50c1ZYXtbj/i9742yarbKMOr4v+SlVBxiKfI5kb6Z0wugUVar12vB027HDFrAk20/wGqlNxDEd0iibVFVwFmvu0oo4Osgb7UvSMpgHHxbKuJ4AM2WHmLbf8vccKSbHEhQh/4u6DWQqOntzwtxZiDxMUufYZ5E+j9L34ZIpZlC14SQ7seT7jfrJiCeWMvWJ0WKeH14cxtTaA=="
        }
      ],
      onSuccess: () => {
        applist.push({ key: "com.webos.chromecast", value: "Chromecast" })
        window.chromecast = true
      },
      onFailure: () => {}
    })

    return applist
  }
  launch = async app_id => {
    if (!app_id) return false
    let promise = await _$.progress.create()
    await __.platform.unfocusing()

    _$.vue.$once("applicationUnfocused", () => promise.resolve())

    /* Library Code */
    const payload = {
      id: app_id.toString(),
      onFailure: payload => promise.reject(payload.errorMessage)
    }

    if (payload.id === "244115188075859013" || payload.id === "netflix") {
      payload.params = {
        params: {
          hotel_id: "7260692151",
          launcher_version: "1.0"
        },
        reason: "launcher"
      }
      payload.noSplash = false
    }

    hcap.preloadedApplication.launchPreloadedApplication(payload)
    /* Library Code */

    return promise.done
  }
  close = async () => {
    let promise = await _$.progress.create()

    _$.vue.$once("applicationFocusing", () => promise.resolve())

    hcap.preloadedApplication.destroyPreloadedApplication({
      id: __.app.isLaunched,
      onFailure: () => {
        hcap.key.sendKey({
          virtualKeycode: hcap.key.Code.EXIT,
          onFailure: payload => promise.reject(payload.errorMessage)
        })
      }
    })

    return promise.done
  }
}

export default App
